import React, { useContext, useEffect, useState } from 'react';
import { NavLink, useHistory, useParams, useLocation } from 'react-router-dom';
import {
  Button,
  Checkbox,
  Footer,
  InfoBox,
  Input,
  Layout,
  MobileTabBar,
  Notification,
  Select,
  SelectFile,
} from '../../../components';

import moment from 'moment';
import '../profile-general.less';
import './title.less';

import { Form, Table, Tabs, Modal, Tooltip, message } from 'antd';

import RightChevronIcon from 'assests/icons/right-chevron.icon';
import UnvanLabel from 'assests/icons/unvan-label.icon';
import { DimensionsContext } from 'context/dimensions.context';
import TickIcon from 'assests/icons/tick.icon';

import { customMessages } from 'utils';
import * as alphaService from 'services/alpha.service';
import { getUserBrandcodes } from 'services/iys.service';
import { getAuthorizationStatus } from 'services/profile.service';
import { useSelector } from 'react-redux';
import ProfileMenu from '../profilemenu';
import NotificationV2 from 'components/Notification/notificationV2';
import { alphaStatus } from 'constants/mapping.const';
const { TabPane } = Tabs;

const Profile = () => {
  const auth = useSelector((state) => state.auth);
  const { isTabletBig, isPhone576 } = useContext(DimensionsContext);
  const [modalIysUpdate, setModalIysUpdate] = useState(false);
  const [modalApplicationStatus, setModalApplicationStatus] = useState(false);
  const [modalTitleData, setModalTitleData] = useState(null);
  let history = useHistory();
  const [form] = Form.useForm();
  let location = useLocation();
  const [messageState, setMessageState] = useState(location.state);
  const [tableData, setTableData] = useState([]);
  const [brandCodes, setBrandCodes] = useState([]);
  const [selectedAlpha, setSelectedAlpha] = useState(null);
  const [isAuthorized, setIsAuthorized] = useState(null);
  const columns = [
    {
      title: 'Ünvan Talebi',
      dataIndex: 'alphaNumericName',
      fixed: isPhone576 ? 'left' : '',
      width: isPhone576 ? 100 : 'auto',
    },
    {
      title: 'Durumu',
      dataIndex: 'status',
      render: (text, record) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <span>{alphaStatus[text]}</span>
        </div>
      ),
    },
    {
      title: 'İYS Numarası',
      dataIndex: 'brandCode',
      render: (text, record) => (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            showIysModal(record);
          }}
        >
          <span style={{ fontWeight: 700 }} className="highlighted">
            {text ? text : 'Yeni İYS Numarası'}
          </span>
        </div>
      ),
    },
    {
      title: '',
      dataIndex: 'creationDate',
      render: (text, record) => (
        <>
          <span>{moment(text).format('DD/MM/YYYY HH:mm')}</span>
          <div className="row-edit">
            <button onClick={() => showModal(record)} type="button">
              Detay <RightChevronIcon />
            </button>
          </div>
        </>
      ),
    },
  ];

  const fetchAlphas = () => {
    alphaService
      .getAlphaNumerics()
      .then((result) => {
        setTableData(result.alphaNumerics);
      })
      .catch((err) => {
        message.error(customMessages.getMessage(err.responseCode));
      });
  };

  const deleteAlphaNumeric = (alphaNumericId) => {
    alphaService
      .deleteAlphaNumeric({ alphaNumericId: alphaNumericId })
      .then((result) => {
        setModalApplicationStatus(false);
        fetchAlphas();
      });
  };

  useEffect(() => {
    getAuthorizationStatus()
      .then((result) => {
        setIsAuthorized(result.properties.isAuthorized);
        if (result.properties.isAuthorized) {
          fetchAlphas();
        }
      })
      .catch((err) => {
        setIsAuthorized(false);
        message.error(customMessages.getMessage(err.responseCode));
      });
  }, []);

  function showModal(record) {
    setModalApplicationStatus(true);
    setModalTitleData(record);
  }

  const showIysModal = (record) => {
    setSelectedAlpha(record);
    fetchBrandCodes(record);
  };

  const fetchBrandCodes = () => {
    getUserBrandcodes()
      .then((result) => {
        setBrandCodes(result.properties.brands);
        setModalIysUpdate(true);
      })
      .catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  };

  const onUpdateBrandCode = (values) => {
    alphaService
      .updateBrandCode({
        alphaNumeric: selectedAlpha.alphaNumericId,
        ...values,
      })
      .then((result) => {
        setModalIysUpdate(false);
        message.success('Başarıyla Kayıt Edildi.');
        fetchAlphas();
      })
      .catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  };

  useEffect(() => {
    if (messageState) {
      NotificationV2(
        'bottomLeft',
        'notification--v2',
        messageState.errorMessage,
        messageState.status
      );
    }
  }, [messageState]);

  useEffect(() => {
    if (!modalIysUpdate) {
      form.resetFields();
    }
  }, [modalIysUpdate]);

  return (
    <Layout>
      <div className="profile-page profile-page--title">
        <div className="container">
          <div className="profile-page__title">
            <h1 className="section__title">Profilim</h1>
          </div>
          <div className="content-wrapper">
            <ProfileMenu></ProfileMenu>
            <div className="profile-page__content">
              <h2 className="box__title">Ünvan Başvurularım</h2>

              {isAuthorized === false && (
                <InfoBox
                  type="warning"
                  content={
                    <p>
                      Bu işlemi yapmaya yetkiliniz yok. 
                      Mesaj Üssü kullanabilmek için işlem yapmak istediğiniz hattın, bağlı 
                      olduğunuz şirketin Özel Şifre Yetkilisi olması gerekmektedir. Lütfen şirketinizin Özel Şifre Yetkilisi ile görüşünüz. Bu numara ile işlem yapmak istiyorsanız, 
                      hattınızın Özel Şifre Yetkilisi olarak tanımlanması için lütfen Turkcell Müşteri Yöneticiniz ile iletişime geçiniz.
                    </p>
                  }
                />
              )}
              {isAuthorized === true && (
                <div className="table-wrapper">
                  <div className="new-permission">
                    <UnvanLabel />
                    <div>
                      <p className="info-text--big">
                        Şirket ünvanlarınızı şimdi ekleyebilir, mesaj
                        oluştururken dilediğiniz ünvanı kolayca seçebilirsiniz.
                      </p>
                      <Button
                        type="primary"
                        shape="round"
                        onClick={() => {
                          history.push({ pathname: `Identity` });
                        }}
                      >
                        Mesaj Başlığı Ekle
                      </Button>
                    </div>
                  </div>
                  <Table
                  rowKey="alphaNumericId"
                    columns={columns}
                    scroll={isPhone576 ? { y: 610, x: 600 } : { y: 610 }}
                    dataSource={tableData}
                    className={
                      isPhone576 ? 'table--guide table--title' : 'table--guide'
                    }
                    pagination={{ position: ['bottomCenter'] }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal getContainer={false}
        title={<span>Başvuru Durumu ({modalTitleData?.alphaNumericName})</span>}
        width={770}
        visible={modalApplicationStatus}
        className="modal-app-status"
        onCancel={() => setModalApplicationStatus(false)}
        footer={null}
      >
        <div className="summary-content">
          <div className="summary-content__row multiple">
            <div>
              <strong>İşlem Tarihi</strong>
              <span>22 Ağustos 2020 Çarşamba 12:34</span>
            </div>
            <div>
              <strong>Durum</strong>
              <span>{alphaStatus[modalTitleData?.status]}</span>
            </div>
          </div>
          {modalTitleData?.status == 'REJECTED' && (
            <div className="summary-content__row">
              <strong>Red Sebebi</strong>
              <p>{modalTitleData?.rejectReason}</p>
            </div>
          )}
        </div>
        <Form form={form} name="rejected-form">
          <div className="modal-action">
            <Button
              shape="round"
              type="ghost"
              onClick={() => setModalApplicationStatus(false)}
            >
              Vazgeç
            </Button>
            {(modalTitleData?.status == 'REJECTED' ||
              modalTitleData?.status == 'ACTIVE') && (
              <Button
                shape="round"
                className="ant-btn-ghost--red"
                type="ghost"
                onClick={() => {
                  deleteAlphaNumeric(modalTitleData?.alphaNumericId);
                }}
              >
                Ünvanı Kaldır
              </Button>
            )}
          </div>
        </Form>
      </Modal>

      <Modal
        title="İYS Marka Bilgileri"
        visible={modalIysUpdate}
        onCancel={() => setModalIysUpdate(false)}
        footer={null}
      >
        <Form
          form={form}
          onFinish={(values) => {
            onUpdateBrandCode(values);
          }}
          name="add-row"
        >
          <span>{selectedAlpha?.alphaNumericName}</span>
          <Form.Item rules={[{ required: true }]} name="brandCode">
            <Select
              compClass="select--big"
              value="xx"
              label="İYS Marka Bilgisi"
              labelvalue="brandName"
              keyvalue="brandCode"
              menuItemSelectedIcon={<TickIcon />}
              data={brandCodes}
            ></Select>
          </Form.Item>
          <div className="modal-action">
            <Button
              shape="round"
              type="ghost"
              onClick={() => setModalIysUpdate(false)}
            >
              Vazgeç
            </Button>
            <Button
              key="confirm"
              type="primary"
              htmlType="submit"
              /*onClick={ () => setModalIysUpdate(fals e) }*/
            >
              Güncelle
            </Button>
          </div>
        </Form>
      </Modal>
      <Footer />
    </Layout>
  );
};

export default Profile;
